import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';
import { XpoLtlAuthGuard } from '@xpo-ltl/ngx-auth';
import { AppRoutes, InbondStorageRoutes, RedeliveryRoutes } from './shared/enums/app-routes.enum';
import { AllowAccessToUiGuard } from '@shared/guards/allow-access-to-the-ui/allow-access-to-ui.guard';

const routerDefinitions: Routes = [
  // {
  //   path: AppRoutes.LANDING_PAGE,
  //   loadChildren: () => import('./landing-page/landing-page.module').then((m) => m.LandingPageModule),
  //   canLoad: [XpoAuthenticationGuard],
  // },
  {
    path: AppRoutes.STORAGE_ACCESSORIAL_CHARGES,
    loadChildren: () => import('./storage-ac/storage-ac.module').then((m) => m.StorageACModule),
    canLoad: [XpoAuthenticationGuard],
  },
  {
    path: InbondStorageRoutes.main,
    loadChildren: () => import('./inbond-storage/inbond-storage.module').then((m) =>
      m.InbondStorageModule),canActivate: [XpoAuthenticationGuard, AllowAccessToUiGuard],
  },
  {
    path: AppRoutes.DETENTION_WITH_POWER,
    loadChildren: () => import('./detention-with-power/detention-with-power.module').then((m) =>
      m.DetentionWithPowerModule),
    canLoad: [XpoAuthenticationGuard],
  },
  {
    path: RedeliveryRoutes.main,
    loadChildren: () => import('./redelivery/redelivery.module').then((m) =>
      m.RedeliveryModule),canActivate: [XpoAuthenticationGuard, AllowAccessToUiGuard],
  },
  
  {
    path: AppRoutes.DETENTION_WITH_POWER_MULTI_PRO,
    loadChildren: () => import('./detention-with-multi-power/detention-with-power-multi-pro.module').then((m) =>
      m.DetentionWithPowerMultiProModule),
    canLoad: [XpoAuthenticationGuard],
  },
  // ADD ANY NEW ROUTE / PAGE HERE
  {
    path: '**',
    redirectTo: AppRoutes.STORAGE_ACCESSORIAL_CHARGES,
  },
];
@NgModule({
  imports: [RouterModule.forRoot([
    {
      path: '',
      canActivate: [XpoAuthenticationGuard, XpoLtlAuthGuard],
      children: routerDefinitions,
    },
  ])],
  exports: [RouterModule],
})
export class AppRoutingModule { }
